/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class GmaoBarChartController {
    /** @ngInject */
    constructor($log, configuration) {
        this.$log = $log;
        this.configuration = configuration;
        this.$log.debug('Controller \'GmaoBarChart\' loaded');
    }

    $onInit() {
        this.chartOptions = {
            chart: {
                type: 'discreteBarChart',
                width: 150,
                height: 200,
                margin : {
                    top: 10,
                    right: 10,
                    bottom: 20,
                    left: 70
                },

                x: record => record ? record.label : record,
                y: record => record ? record.value : record,

                area: true,
                showValues: true,
                valueFormat: value => value
            }
        };
    }
}

export { GmaoBarChartController };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/statistics/component/GmaoBarChart.js